export const getDashboardTask = state => state.dashboardTask.tasks
